import { useEffect, useState } from 'react'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import { useRouter } from 'next/router'
import useCountdown from 'hooks/useCountdown'
import usePush from 'hooks/usePush'
import { useStore } from 'store/state/store'
import { launchTimerStart, launchTimerEnd, launchTimerEnabled, bypassKey } from 'src/data/constants'

dayjs.extend(isBetween)

export default function useLaunchTimer() {
  const bypass = useStore((state) => state.bypass)
  const isBypassed = bypass === bypassKey

  const startTime = dayjs(launchTimerStart)
  const endTime = dayjs(launchTimerEnd)
  const diff = +endTime.diff(startTime)
  const showTimer =
    launchTimerEnabled && !isBypassed && dayjs().isBetween(launchTimerStart, launchTimerEnd)

  const { timer, countdown } = useCountdown(+endTime, !isBypassed)

  const [isReady, setIsReady] = useState(false)

  // prevents text mismatch after hydration
  useEffect(() => {
    if (!isReady) {
      setIsReady(true)
    }
  }, [isReady])

  const { pathname } = useRouter()
  const push = usePush()

  // redirect to home if countdown is active
  useEffect(() => {
    if (!isBypassed && showTimer && pathname !== '/') {
      push('/')
    }
  }, [isBypassed, pathname, push, showTimer])

  return {
    isReady,
    showTimer,
    diff,
    timer,
    countdown
  }
}
